<template>
    <ListPublication/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  

import ListPublication from "@/components/Publication/ListPublication.vue";

    export default defineComponent({
      name: "ListePublicationPage",
      components: {
        
        ListPublication,
      },
    });
  </script>